export * from "./pagination.component";
